module.exports = "production"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./LOCALE
// module id = 3
// module chunks = 0